import { IconButton } from '@mui/material';
import { canPlayVideoUrl } from '@strength/domain';
import { MdClose } from '@teamworksdev/icons';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

export const VideoPreviewPlayer = ({
  videoUrl,
  onClose,
}: {
  videoUrl: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="relative">
        {canPlayVideoUrl(videoUrl) ? (
          <ReactPlayer url={videoUrl} controls={true} playing={true} />
        ) : (
          <p className="text-white p-4">{t('videoUnavailable')}</p>
        )}
        <IconButton className="absolute top-2 right-2" onClick={onClose}>
          <MdClose size={24} color="white" />
        </IconButton>
      </div>
    </div>
  );
};
